<template>
      <div class="ui raised clearing segment">
        <div class="header" style="padding-bottom: 10px; border-bottom: 1px solid #eeeeee">
          <div style="display: inline-block; width: 100px; font-size: 16px;">
            <strong><a href="#" @click.prevent="triggerDetails">{{ reservation.code }}</a></strong>
          </div>
          <div style="display: inline-block; width: 130px">
            <i class="user icon"></i> {{ reservation.contact.firstName}} {{ reservation.contact.lastName}}
          </div>
          <div style="display: inline-block; width: 220px;">
            <i class="ship icon"></i> {{ reservation.boat.name }}
          </div>
          <div style="display: inline-block; width: 180px">
            {{ moment(reservation.firstBooking.date).format('ll') }}: <strong class="ui basic large label">{{ starts }} - {{ ends }}h</strong>
          </div>
          <div style="display: inline-block; width: 120px">
            <div class="ui label" v-if="reservation.confirmed">{{ reservation.status }}</div>
            <div class="ui yellow label" v-else>unconfirmed</div>
          </div>
          <div style="display: inline-block; width: 120px">
            <div class="ui small icon label" v-if="reservation.payment.status == 'paid'"><i class="checkmark icon"></i> Paid</div>
            <div class="ui small label" :class="{ 'red': reservation.status == 'returned' && reservation.payment.status == 'unpaid' }" v-if="reservation.payment.status == 'unpaid'">Unpaid: <strong>€{{reservation.payment.toPay}}</strong></div>
            <div class="ui small label" :class="{ 'orange': reservation.payment.status == 'refund' }" v-if="reservation.payment.status == 'refund'">Refund: -<strong>€{{ Math.abs(reservation.payment.toPay) }}</strong></div>
          </div>
          <div style="float: right">
            <div class="ui tiny buttons">
              <div class="ui button" @click="checkIn" v-if="reservation.status == 'reserved'"><i class="sign in icon"></i> Check In</div>
              <div class="ui button" @click="paid"
                   v-if="reservation.status == 'inProgress' ||
                   reservation.status == 'checkIn' ||
                   (reservation.status == 'returned' && (reservation.payment.status == 'unpaid' || reservation.payment.status == 'refund'))"><i class="money icon"></i> Paid</div>
              <!--<div class="ui button" @click="checkOut" v-else-if="reservation.payment.status == 'paid'"><i class="sign out icon"></i> Check Out</div>-->
              <div class="ui floating dropdown blue icon button" @click.stop="">
                <i class="dropdown icon"></i>
                <div class="menu">
                  <div class="item" @click="checkIn"><i class="sign in icon"></i> Check In</div>
                  <div class="item" @click="paid"><i class="money icon"></i> Paid</div>
                  <div class="item" @click="checkOut"><i class="sign out icon"></i> Check Out</div>
                  <div class="divider"></div>
                  <div class="item" @click="triggerDetails"><i class="list icon"></i> View Details</div>
                </div>
              </div>
            </div>
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="content bordered" style="padding: 10px 0; border-bottom: 1px solid #eeeeee; font-size: 13px">
          <strong>Booked At:</strong> {{ moment(reservation.createdAt).format('MMM DD, HH:mm') }}
          &bull; <strong>People:</strong> {{ reservation.people }}
          &bull; <strong>Telephone:</strong> {{ reservation.contact.tel }}
          &bull; <strong>Email:</strong> {{ reservation.contact.email }}
          <span v-if="reservation.contact.company"> &bull; <strong>Company:</strong> {{ reservation.contact.company }}</span>
          <span v-if="reservation.discount"> &bull; <strong>Voucher:</strong> {{ reservation.discount.voucher }}</span>
          <br>
          Reason: {{ reservation.reason }}
        </div>
        <div class="content bordered" style="padding: 10px 0; border-bottom: 1px solid #eeeeee" v-if="reservation.wishes">
          <div style="float: right">
            <div class="ui dropdown">
              <div class="text">
                <span v-if="!reservation.wishesStatus || reservation.wishesStatus === 'pending'" class="pending service status"><i class="wait icon"></i> Pending</span>
                <span v-if="reservation.wishesStatus === 'inProgress'" class="in-progress service status"><i class="refresh icon"></i> In Progress</span>
                <span v-if="reservation.wishesStatus === 'takenCare'" class="delivered service status"><i class="checkmark icon"></i> Taken Care</span>
                <span v-if="reservation.wishesStatus === 'escalated'" class="problem service status"><i class="alarm outline icon"></i> Escalated</span>
              </div>
              <i class="dropdown icon"></i>
              <div class="menu" @click.prevent>
                <div class="item" @click.prevent.stop="wishesStatus('pending')"><i class="wait icon"></i> Pending</div>
                <div class="item" @click.prevent.stop="wishesStatus('inProgress')"><i class="refresh icon"></i> In Progress</div>
                <div class="item" @click.prevent.stop="wishesStatus('takenCare')"><i class="checkmark icon"></i> Taken Care</div>
                <div class="ui divider"></div>
                <div class="item" @click.prevent.stop="wishesStatus('escalated')"><i class="alarm outline icon"></i> Escalated</div>
              </div>
            </div>
          </div>
          <strong>WISHES:</strong><br>{{ reservation.wishes }}
          <div style="clear: both"></div>
        </div>
        <div class="content bordered" style="padding: 10px 0; border-bottom: 1px solid #eeeeee" v-if="reservation.questions">
          <div style="float: right">
            <div class="status-block">
              <div class="ui dropdown">
                <div class="text">
                  <span v-if="!reservation.questionsStatus || reservation.questionsStatus === 'pending'" class="pending service status"><i class="wait icon"></i> Pending</span>
                  <span v-if="reservation.questionsStatus === 'inProgress'" class="in-progress service status"><i class="refresh icon"></i> In Progress</span>
                  <span v-if="reservation.questionsStatus === 'takenCare'" class="delivered service status"><i class="checkmark icon"></i> Taken Care</span>
                  <span v-if="reservation.questionsStatus === 'escalated'" class="problem service status"><i class="alarm outline icon"></i> Escalated</span>
                </div>
                <i class="dropdown icon"></i>
                <div class="menu" @click.prevent>
                  <div class="item" @click.prevent.stop="questionsStatus('pending')"><i class="wait icon"></i> Pending</div>
                  <div class="item" @click.prevent.stop="questionsStatus('inProgress')"><i class="refresh icon"></i> In Progress</div>
                  <div class="item" @click.prevent.stop="questionsStatus('takenCare')"><i class="checkmark icon"></i> Taken Care</div>
                  <div class="ui divider"></div>
                  <div class="item" @click.prevent.stop="questionsStatus('escalated')"><i class="alarm outline icon"></i> Escalated</div>
                </div>
              </div>
            </div>
          </div>
          <strong>QUESTIONS:</strong><br>

          {{ reservation.questions }}
          <div style="clear: both"></div>
        </div>
        <div class="content bordered" style="padding: 10px 0" v-if="reservation.services && reservation.services.length > 0">
          <strong>SERVICES:</strong><br>
          <div class="service row" v-for="service in reservation.services">
            {{ service.title }}
            <div style="float: right">
              <div class="ui mini labeled input" v-if="service.priceType === 'perPerson'">
                <div class="ui label">
                  P
                </div>
                <input type="number" v-model="service.people" style="width: 60px">
              </div>
              <div class="ui basic tiny button" @click="toggleBillStatus(service._id)">
                <span v-if="service.billed"><i class="checkmark icon"></i> Billed</span>
                <span v-else><i class="delete icon"></i> Off Bill</span>
              </div>
              <div class="status-block">
                <div class="ui dropdown">
                  <div class="text">
                    <span v-if="!service.status || service.status === 'pending'" class="pending service status"><i class="wait icon"></i> Pending</span>
                    <span v-if="service.status === 'inProgress'" class="in-progress service status"><i class="refresh icon"></i> In Progress</span>
                    <span v-if="service.status === 'delivered'" class="delivered service status"><i class="checkmark icon"></i> Delivered</span>
                    <span v-if="service.status === 'escalated'" class="problem service status"><i class="alarm outline icon"></i> Escalated</span>
                  </div>
                  <i class="dropdown icon"></i>
                  <div class="menu" @click.prevent>
                    <div class="item" @click.prevent.stop="serviceStatus(service._id, 'pending')"><i class="wait icon"></i> Pending</div>
                    <div class="item" @click.prevent.stop="serviceStatus(service._id, 'inProgress')"><i class="refresh icon"></i> In Progress</div>
                    <div class="item" @click.prevent.stop="serviceStatus(service._id, 'delivered')"><i class="checkmark icon"></i> Delivered</div>
                    <div class="ui divider"></div>
                    <div class="item" @click.prevent.stop="serviceStatus(service._id, 'escalated')"><i class="alarm outline icon"></i> Escalated</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>

<script type="text/ecmascript-6">
  import * as services from './../../../services/'

  export default {
    data() {
      return {
        'moment': moment
      }
    },
    mounted() {

    },
    computed: {
      starts() {
        return this.reservation.bookings[0].hour.split(' - ')[0]
      },
      ends() {
        return this.reservation.bookings[this.reservation.bookings.length - 1].hour.split(' - ')[1]
      }
    },
    methods: {
      triggerMenu() {
        $('.ui.sidebar').sidebar('toggle')
      },
      checkIn() {
        services.reservationService.patch(this.reservation._id, { 'status': 'checkIn' }).then(reservation => {
          toastr.success('Visitor checked in')
//          this.$emit('printReceipt', this.reservation)
        })
      },
      paid() {
        services.reservationService.patch(this.reservation._id, { 'payment.status': 'paid' }).then(reservation => {
          toastr.success('Visitor has paid')
        })
      },
      checkOut() {
        services.reservationService.patch(this.reservation._id, { 'status': 'checkOut' }).then(reservation => {
          toastr.success('Visitor has checked out')
        })
      },
      questionsStatus(status) {
        $('.ui.dropdown').dropdown('hide')

        services.reservationService.patch(this.reservation._id, { 'questionsStatus': status }).then(reservation => {
          toastr.success('Status of questions updated.')
        })
      },
      serviceStatus(serviceId, status) {
        $('.ui.dropdown').dropdown('hide')

        for (let service of this.reservation.services) {
          if (service._id === serviceId) service.status = status
        }

        services.reservationService.patch(this.reservation._id, { 'services': this.reservation.services }).then(reservation => {
          toastr.success('Service status updated')
        })
      },
      wishesStatus(status) {
        $('.ui.dropdown').dropdown('hide')

        services.reservationService.patch(this.reservation._id, { 'wishesStatus': status }).then(reservation => {
          toastr.success('Status of questions updated.')
        })
      },
      toggleBillStatus(serviceId) {
        for (let service of this.reservation.services) {
          if (service._id === serviceId) {
            if ('billed' in service) {
              service.billed = !service.billed
            } else {
              service.billed = true
            }
          }
        }

        services.reservationService.patch(this.reservation._id, { 'services': this.reservation.services }).then(reservation => {
          toastr.success('Service status updated')
        })

      },
      triggerDetails() {
          this.$emit('triggerDetails', this.reservation)
      }
    },
    props: [
        'reservation'
    ],
    components: {
    }
  }
</script>

<style scoped>
  .no.wrap {
    white-space: nowrap;
  }
  .ui.basic.buttons .active.button.in-progress {
    background: #657fff !important;
    color: #ffffff !important;
  }
  .ui.basic.buttons .active.button.delivered {
    background: #46a347 !important;
    color: #ffffff !important;
  }
  .ui.basic.buttons .active.button.problem {
    background: #cd3d35 !important;
    color: #ffffff !important;
  }
  .service.row {
    border-bottom: 1px solid #eeeeee;
    padding: 10px 0;
    line-height: 24px;
  }
  .pending.service.status {
    color: #ff7633;
  }
  .in-progress.service.status {
    color: #5571ff;
  }
  .delivered.service.status {
    color: #25973a;
  }
  .problem.service.status {
    color: #cd1b1c;
  }
  .status-block {
    display: inline-block;
    text-align: right;
    width: 140px;
  }
</style>



// WEBPACK FOOTER //
// ReservationRow.vue?5509e85f